import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./lib/auth";
import { MetaProvider } from "./lib/meta";
import "./index.css";

const isDemo = import.meta.env.VITE_DEMO === "true";

async function bootstrap() {
  // The demo is static hosting with no server, so routes live in the hash and
  // the API is answered from a recorded snapshot. Both are compiled out of
  // the real build: VITE_DEMO is a literal, so this branch disappears.
  if (isDemo) {
    const { installDemoApi } = await import("./demo/install");
    installDemoApi();
  }

  const Router = isDemo ? HashRouter : BrowserRouter;

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <Router>
        <AuthProvider>
          <MetaProvider>
            <App />
          </MetaProvider>
        </AuthProvider>
      </Router>
    </StrictMode>,
  );
}

void bootstrap();
